/**
 * General utility type guards for runtime type checking.
 */

/**
 * Type guard to check if a value is a non-null object.
 * This is useful as a base check before performing property checks.
 *
 * @param value - The value to check
 * @returns True if the value is a non-null object
 */
export function isNonNullObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/**
 * Helper to check if an array contains items of a specific type.
 *
 * @param arr - The array to check
 * @param guard - The type guard function to apply to each element
 * @returns True if the array contains only items matching the type guard
 */
export function isArrayOf<T>(
  arr: unknown,
  guard: (item: unknown) => item is T
): arr is T[] {
  return Array.isArray(arr) && arr.every(guard);
}
